import React from "react";
import { Phone, MessageSquare, Mail } from "lucide-react";
import EstimateForm from "../components/EstimateForm";
import LocationCard from "../components/LocationCard";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { contactPage, seo, business } from "../data/siteData";

export default function Contact() {
  useSeo(seo["/contact-us"].title, seo["/contact-us"].description);
  useReveal();
  return (
    <>
      <section className="border-b-4 border-[#244aa2] bg-[#f7f7f7] py-12">
        <div className="mr-container">
          <h1 className="mr-h1 text-3xl sm:text-4xl">{contactPage.h1}</h1>
          <h2 className="font-head mt-4 max-w-3xl text-lg font-bold leading-snug text-[#244aa2]">
            Text a picture of your project to{" "}
            <a href={`sms:1${business.phoneDigits}`} className="underline hover:text-[#a10000]">
              203-578-5260
            </a>{" "}
            for a free estimate on your resurfacing project.
          </h2>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={`tel:${business.phoneRaw}`}
              className="flex items-center gap-2 bg-[#244aa2] px-7 py-3 text-[12px] font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-[#0c2a66]"
            >
              <Phone className="h-4 w-4" /> Call {business.phone}
            </a>
            <a
              href={`sms:1${business.phoneDigits}`}
              className="flex items-center gap-2 bg-[#a10000] px-7 py-3 text-[12px] font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-[#7d0000]"
            >
              <MessageSquare className="h-4 w-4" /> Text Photos
            </a>
            <a
              href={`mailto:${business.email}`}
              className="flex items-center gap-2 border-2 border-[#244aa2] px-7 py-3 text-[12px] font-bold uppercase tracking-wide text-[#244aa2] transition-colors duration-200 hover:bg-[#244aa2] hover:text-white"
            >
              <Mail className="h-4 w-4" /> {business.email}
            </a>
          </div>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mr-container-wide grid gap-10 lg:grid-cols-3">
          <div className="mr-body reveal lg:col-span-2">
            {contactPage.paragraphs.map((p) => (
              <p key={p.slice(0, 30)} className="text-[16.5px]">
                {p}
              </p>
            ))}
            <div className="mt-10 border border-neutral-200 p-6 sm:p-8">
              <EstimateForm title={contactPage.formTitle} />
            </div>
          </div>
          <div className="reveal">
            <LocationCard />
            <div className="mt-6 overflow-hidden border border-neutral-200">
              <iframe
                title="Mr. Resurface LLC location map"
                src="https://www.google.com/maps?q=1776+Meriden+Rd,+Wolcott,+CT+06716&output=embed"
                className="h-[280px] w-full"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
